<template>
    <section class="accordion">
        <div v-for="(item, index) in items" :key="index" class="accordion__item">
            <button :class="['accordion__header', {'active' : isActive(index)}]" :aria-expanded="isActive(index)" @click="toggle(index)"
                :aria-controls="'accordion-content-' + index" :id="'accordion-header-' + index">
                <span class="accordion__title">{{ item.title }}</span>
                <span class="accordion__icon" aria-hidden="true">
                    <svg :class="['accordion__icon-arrow', {'active' : isActive(index)}]">
                        <use xlink:href="#icon-prev"></use>
                    </svg>
                </span>
            </button>
            <div v-if="isActive(index)" class="accordion__body" :id="'accordion-content-' + index"
                :aria-labelledby="'accordion-header-' + index">
                <slot :name="item.key" />
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps({
    items: {
        type: Array,
        required: true,
        default: () => []
    },
    modelValue: {
        type: Number,
        default: null
    },
    isAccordionOpenByDefault: {
        type: Boolean,
        default: false
    }
});

const activeIndexArray = ref(props.isAccordionOpenByDefault ? Array.from({ length: props.items.length }, (_, i) => i) : []);

const toggle = (index) => {
    const currentIndex = activeIndexArray.value.indexOf(index);
    if (currentIndex > -1) {
        // Index exists, remove it to close the item
        activeIndexArray.value.splice(currentIndex, 1);
    } else {
        // Index does not exist, add it to open the item
        activeIndexArray.value.push(index);
    }
};

const isActive = (index) => {
    return activeIndexArray.value?.includes(index);
};

</script>